import toast from "react-hot-toast";
import api from "../api";
import { ApiErrors } from "./errors";
import { DebouncedFunc } from "lodash";
import { AxiosError } from "axios";

interface APIInterceptorProps {
  debouncedExpireSession: DebouncedFunc<() => void>;
}

export function initAPIInterceptor({
  debouncedExpireSession,
}: APIInterceptorProps) {
  api.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
      if (error.response) {
        if (error.response.status === 401 || error.response.status === 403) {
          switch (error.response.data.error as string) {
            case ApiErrors.UNAUTHORIZED:
              return debouncedExpireSession();
            case ApiErrors.INSUFFICIENT_PERMISSIONS:
            default:
              return toast.error(error.response.data.error);
          }
        }
        return Promise.reject(error);
      }
      return Promise.reject(error);
    },
  );
}
